module.exports = __webpack_public_path__ + "static/media/how_it_works_3.e1038616.png";